import React, { useMemo } from "react";
import { motion } from "framer-motion";

export default function MEKRONLanding() {
  const features = useMemo(
    () => [
      "Proven expertise in AI & automation",
      "Tailored solutions to your business",
      "24/7 operations — zero downtime",
      "Cost efficiency & zero‑error outputs",
    ],
    []
  );

  const box = {
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    padding: 24,
    background: "#fff",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  };

  return (
    <div style={{ fontFamily: "system-ui, Arial", background: "#f6f7f9", minHeight: "100vh" }}>
      {/* Header */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 12, background: "#111", color: "#fff", display: "grid", placeItems: "center", fontWeight: 800 }}>M</div>
          <div style={{ fontWeight: 900, fontSize: 20 }}>MEKRON</div>
        </div>
        <a href="#contact" style={{ padding: "10px 14px", borderRadius: 12, background: "#111", color: "#fff", textDecoration: "none" }}>
          Book a Demo
        </a>
      </div>

      {/* Hero */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 20px", display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 28 }}>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <h1 style={{ fontSize: 42, lineHeight: 1.2, margin: 0, fontWeight: 900 }}>
            AI Automation that runs <span style={{ color: "#555" }}>24/7</span>
          </h1>
          <p style={{ marginTop: 14, color: "#494949", fontSize: 18 }}>
            Replace repetitive processes with intelligent, self‑learning systems. Yron 1 optimizes,
            decides, and executes with zero fatigue. <br />
            <span style={{ color: "#6b7280" }}>الأتمتة الذكية بالعربية والإنجليزية — تشغيل بلا توقف.</span>
          </p>
          <div style={{ marginTop: 18, display: "flex", gap: 10 }}>
            <a href="#contact" style={{ padding: "12px 16px", borderRadius: 12, background: "#111", color: "#fff", textDecoration: "none" }}>
              Start your transformation
            </a>
            <a href="#why" style={{ padding: "12px 16px", borderRadius: 12, border: "1px solid #ddd", textDecoration: "none", color: "#111", background: "#fff" }}>
              Why MEKRON
            </a>
          </div>
        </motion.div>

        <motion.div style={box} initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: 0.1 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {[
              { k: "Uptime", v: "99.98%" },
              { k: "Error Rate", v: "0%" },
              { k: "Response", v: "< 200ms" },
              { k: "Cost", v: "↓ 40%" },
            ].map((m, i) => (
              <div key={i} style={{ border: "1px solid #eee", borderRadius: 12, padding: 12, background: "#fafafa" }}>
                <div style={{ fontSize: 12, color: "#6b7280" }}>{m.k}</div>
                <div style={{ fontSize: 22, fontWeight: 800 }}>{m.v}</div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 14, borderRadius: 12, padding: 14, background: "#111", color: "#fff" }}>
            <div style={{ opacity: 0.7, fontSize: 13 }}>Yron 1 — AI Ops</div>
            <div style={{ fontWeight: 700 }}>Monitors • Decides • Executes — with human oversight</div>
          </div>
        </motion.div>
      </div>

      {/* Why */}
      <div id="why" style={{ maxWidth: 1100, margin: "0 auto", padding: "20px" }}>
        <h2 style={{ fontSize: 30, fontWeight: 900 }}> Why MEKRON?</h2>
        <ul style={{ marginTop: 12, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14, padding: 0, listStyle: "none" }}>
          {features.map((f, i) => (
            <li key={i} style={box}>{f}</li>
          ))}
        </ul>
      </div>

      {/* Contact */}
      <div id="contact" style={{ background: "#111", color: "#fff", marginTop: 24 }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "26px 20px", display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 24 }}>
          <div>
            <div style={{ fontSize: 28, fontWeight: 900 }}>Book a Live Demo / احجز عرضًا حيًا</div>
            <p style={{ color: "#ddd" }}>Show us your bottlenecks. We’ll automate them in days. ورينا الاختناقات… هنؤتمتها سريعًا.</p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <a href="mailto:hello@mekron.ai" style={{ padding: "10px 14px", borderRadius: 12, background: "#fff", color: "#111", textDecoration: "none" }}>
                mekronaiautomation@gmail.com
              </a>
              <span style={{ padding: "10px 14px", borderRadius: 12, border: "1px solid #444" }}>+201289163517</span>
            </div>
          </div>
          <form onSubmit={(e) => e.preventDefault()} style={{ ...box, background: "rgba(255,255,255,0.06)", color: "#fff", borderColor: "#333" }}>
            <input placeholder="Full name / الاسم" style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #333", marginBottom: 8 }} />
            <input placeholder="Company / الشركة" style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #333", marginBottom: 8 }} />
            <input placeholder="Email / البريد الإلكتروني" style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #333", marginBottom: 8 }} />
            <textarea placeholder="What do you want to automate? / عايز تعمل اتمته لأيه ؟" rows={4} style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #333" }} />
            <button style={{ marginTop: 10, padding: "10px 14px", borderRadius: 10, background: "#fff", color: "#111", fontWeight: 700 }}>
              Request Demo
            </button>
          </form>
        </div>
      </div>

      {/* Footer */}
      <div style={{ textAlign: "center", padding: 18, color: "#6b7280" }}>
        © {new Date().getFullYear()} MEKRON — End-to-End Automation Company
      </div>
    </div>
  );
}
